import { $, $$ } from 'utils/dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Swiperslider from 'modules/swiper/swiper';
import { viewport } from '../getViewport';

export const storyHighlights = () => {
  const highlights = $$('.story-highlights');

  if (highlights.length) {
    highlights.forEach(item => {
      const slider = new Swiperslider($('.story-highlights__slider', item), {
        container: item,
        sliderOptions: {
          breakpoints: {
            768: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          },
        },
      });
      slider.init();
    });

    const items = $$('.story-highlights__item');
    const timeline = gsap.timeline();

    items.forEach(item => {
      gsap.set(item, {
        y: viewport.isReduced
          ? 0
          : viewport.isDesktop
          ? 50
          : viewport.isTablet
          ? 50
          : viewport.isMobile
          ? 0
          : '',
      });

      timeline.to(item, {
        y: 0,
        stagger: {
          each: 1,
        },
      });
    });

    highlights.forEach(teaser => {
      ScrollTrigger.create({
        animation: timeline,
        trigger: teaser,
        start: () => 'top 70%',
        end: () => 'top 40%',
        toggleActions: 'play pause resume reset',
        scrub: 1,
      });
    });
  }
};
